export default __webpack_public_path__ + "static/media/eatingFood.a5dd3d3b.gif";